(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[239],{

/***/ 5953:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/template",
      function () {
        return __webpack_require__(403);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5578);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(102);


const Button = (param)=>{
    let { children , ...rest } = param;
    return(// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(StyledButton, {
        type: "button",
        ...rest,
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);
const StyledButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("button", {
    target: "epqktyx0"
})("all:unset;cursor:pointer;background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, ";border-radius:8px;padding:12px;font-size:1rem;text-align:center;transition:background-color 0.2s;&:active{background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.gray5;
}, ";}&:disabled{background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.gray3;
}, ";}");


/***/ }),

/***/ 7566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5578);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2746);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(102);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6875);




const ContainedButton = (param)=>{
    let { children , size ="medium" , ...rest } = param;
    return(// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(StyledContainedButton, {
        size: size,
        ...rest,
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ContainedButton);
const StyledContainedButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    target: "e98hc0x0"
})("width:100%;", (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.button2
    };
}, " ", (param)=>{
    let { size  } = param;
    return size === "medium" && mediumCss;
}, " ", (param)=>{
    let { size  } = param;
    return size === "large" && largeCss;
});
const mediumCss = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.css)("padding:8px 0;");
const largeCss = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.css)("padding:12px 0;");


/***/ }),

/***/ 1919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5578);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2746);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(102);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6875);




const LabelButton = (param)=>{
    let { children , size ="small" , withIcon =false , ...rest } = param;
    return(// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(StyledLabelButton, {
        size: size,
        withIcon: withIcon,
        ...rest,
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (LabelButton);
const StyledLabelButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    target: "e10ugv0c0"
})("padding:8px;background-color:inherit;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.gray5;
}, ";display:flex;align-items:center;&:active{background-color:inherit;}&:disabled{background-color:inherit;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.gray3;
}, ";}", (param)=>{
    let { size  } = param;
    return size === "small" && smallCss;
}, " ", (param)=>{
    let { theme , withIcon  } = param;
    return withIcon && withIconCss(theme);
});
const smallCss = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.css)("font-size:12px;");
const withIconCss = (theme)=>/*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.css)("color:", theme.colors.gray3, ";");


/***/ }),

/***/ 2986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5578);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9953);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(102);
/* harmony import */ var _icon_IconCheckbox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9077);




const Checkbox = (param)=>{
    let { onToggle , checked , textLabel , testId  } = param;
    const id = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(CheckboxWrapper, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(StyledInput, {
                type: "checkbox",
                onChange: (e)=>{
                    onToggle === null || onToggle === void 0 ? void 0 : onToggle(e);
                },
                id: id,
                checked: checked
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(StyledLabel, {
                htmlFor: id,
                children: [
                    textLabel && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(TextLabel, {
                        children: textLabel
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(IconWrapper, {
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_icon_IconCheckbox__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            isChecked: checked
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Checkbox);
const CheckboxWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "eiewy6k0"
})("display:inline-block;");
const StyledInput = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("input", {
    target: "eiewy6k1"
})("overflow:hidden;position:absolute;width:1px;height:1px;margin:-1px;clip-path:polygon(0 0,0 0,0 0);");
const StyledLabel = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("label", {
    target: "eiewy6k2"
})("display:flex;align-items:center;");
const TextLabel = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("span", {
    target: "eiewy6k3"
})((param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.caption2
    };
}, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.gray5;
}, ";padding:8px;");
const IconWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "eiewy6k4"
})("width:40px;height:40px;padding:8px;");


/***/ }),

/***/ 4:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5578);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(102);
/* harmony import */ var _Checkbox__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2986);



const CheckboxWithText = (param)=>{
    let { children , ...rest } = param;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_Checkbox__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                ...rest
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(TextWrapper, {
                children: children
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CheckboxWithText);
const Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "empok290"
})("display:flex;align-items:center;");
const TextWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "empok291"
})((param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.body1
    };
}, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.gray6;
}, ";margin-left:4px;");


/***/ }),

/***/ 5110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5578);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(102);
/* harmony import */ var _icon_IconInfo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9340);



const Chip = (param)=>{
    let { label , color ="default" , icon , onClick  } = param;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(Wrapper, {
        color: color,
        onClick: onClick,
        children: [
            icon !== null && icon !== void 0 ? icon : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_icon_IconInfo__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                width: 16,
                height: 16,
                viewBox: "0 0 16 16"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("span", {
                children: label
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Chip);
const Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span", {
    target: "eul0ouq0"
})({
    display: "inline-flex",
    alignItems: "center",
    padding: "8px 16px",
    borderRadius: "50px",
    "*:first-of-type": {
        marginRight: "4px"
    }
}, (param)=>{
    let { theme , color  } = param;
    return {
        ...theme.typographies.body1,
        fontWeight: 500,
        ...color === "default" && {
            backgroundColor: theme.colors.white,
            color: theme.colors.gray4
        },
        ...color === "black" && {
            backgroundColor: theme.colors.black,
            color: theme.colors.white
        },
        ...color === "gray" && {
            backgroundColor: theme.colors.gray1,
            color: theme.colors.gray4
        }
    };
});


/***/ }),

/***/ 2976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5578);
/* harmony import */ var _svg_Svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4555);


const IconAdd = (param)=>/*#__PURE__*/ {
    let { ...rest } = param;
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_svg_Svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        ...rest,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
            d: "M12 6.5V12M12 12V17.5M12 12H17.5M12 12H6.5",
            stroke: "#C7C7D0",
            strokeWidth: "1.5",
            strokeLinecap: "round"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconAdd);


/***/ }),

/***/ 4677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5578);
/* harmony import */ var _svg_Svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4555);


const IconAlarm = (param)=>/*#__PURE__*/ {
    let { isNew =false , ...rest } = param;
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_svg_Svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        ...rest,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.3995 12.6659L21.2812 15.2319C22.2582 16.564 21.3068 18.4414 19.6548 18.4414L4.32061 18.4414C2.6686 18.4414 1.71727 16.564 2.69421 15.2319L4.57586 12.666L4.57586 8.91203C4.57586 4.81859 7.89426 1.50019 11.9877 1.50019C16.0811 1.50019 19.3995 4.81858 19.3995 8.91203L19.3995 12.6659Z",
                fill: "#9090A0"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.49243 20.0298C9.00124 21.469 10.3739 22.5002 11.9874 22.5002C13.6009 22.5002 14.9736 21.469 15.4824 20.0298H8.49243Z",
                fill: "#9090A0"
            }),
            isNew && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("circle", {
                cx: "22",
                cy: "2",
                r: "2",
                fill: "#F5656A"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconAlarm);


/***/ }),

/***/ 5943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5578);
/* harmony import */ var _svg_Svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4555);


const IconCancel = (param)=>/*#__PURE__*/ {
    let { ...rest } = param;
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_svg_Svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        ...rest,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
            d: "M19.0711 5.07107L12 12.1421M12 12.1421L4.92893 19.2132M12 12.1421L19.0711 19.2132M12 12.1421L4.92893 5.07107",
            stroke: "#9090A0",
            strokeWidth: "1.5",
            strokeLinecap: "round"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconCancel);


/***/ }),

/***/ 9077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5578);
/* harmony import */ var _svg_Svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4555);


const IconCheckbox = (param)=>{
    let { isChecked =false , ...rest } = param;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_svg_Svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        ...rest,
        children: isChecked ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("g", {
                    clipPath: "url(#clip0_1245_54761)",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M6 0C4.4087 0 2.88258 0.632141 1.75736 1.75736C0.632141 2.88258 0 4.4087 0 6V18C0 19.5913 0.632141 21.1174 1.75736 22.2426C2.88258 23.3679 4.4087 24 6 24H18C19.5913 24 21.1174 23.3679 22.2426 22.2426C23.3679 21.1174 24 19.5913 24 18V6C24 4.4087 23.3679 2.88258 22.2426 1.75736C21.1174 0.632141 19.5913 0 18 0H6ZM16.476 10.4208C16.5838 10.3058 16.6679 10.1706 16.7234 10.0231C16.779 9.87556 16.8049 9.71853 16.7998 9.56097C16.7947 9.40341 16.7586 9.24839 16.6936 9.10479C16.6285 8.96118 16.5358 8.83179 16.4208 8.724C16.3058 8.61621 16.1706 8.53214 16.0231 8.47657C15.8756 8.42101 15.7185 8.39506 15.561 8.40018C15.4034 8.40531 15.2484 8.44142 15.1048 8.50645C14.9612 8.57148 14.8318 8.66416 14.724 8.7792L11.0244 12.7272L9.1968 11.1036C8.95735 10.9045 8.6499 10.8064 8.3394 10.8298C8.0289 10.8532 7.73966 10.9964 7.53279 11.2291C7.32592 11.4619 7.21761 11.7659 7.23075 12.077C7.24389 12.3881 7.37744 12.6819 7.6032 12.8964L10.3032 15.2964C10.5368 15.5039 10.8422 15.6121 11.1544 15.598C11.4665 15.5839 11.7609 15.4486 11.9748 15.2208L16.4748 10.4208H16.476Z",
                        fill: "#212121"
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("defs", {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("clipPath", {
                        id: "clip0_1245_54761",
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("rect", {
                            width: "24",
                            height: "24",
                            fill: "white"
                        })
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("rect", {
            width: "24",
            height: "24",
            rx: "6",
            fill: "#C7C7D0"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconCheckbox);


/***/ }),

/***/ 4149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5578);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(102);
/* harmony import */ var _svg_Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4555);



const DIRECTION_DEGREE = {
    right: 0,
    left: 180
};
const IconChevron24pxRightLeft = (param)=>{
    let { direction ="right" , ...rest } = param;
    return(// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(StyledSvg, {
        degree: DIRECTION_DEGREE[direction],
        ...rest,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
            d: "M10 19L16.6464 12.3536C16.8417 12.1583 16.8417 11.8417 16.6464 11.6464L10 5",
            stroke: "#626273",
            strokeWidth: "1.5",
            strokeLinecap: "round"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (IconChevron24pxRightLeft);
const StyledSvg = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_svg_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    target: "e1osa9c50"
})("transform:rotate(", (param)=>{
    let { degree  } = param;
    return degree;
}, "deg);");


/***/ }),

/***/ 5099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5578);
/* harmony import */ var _svg_Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4555);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2429);



const HOME_COLOR = (isAct)=>isAct ? {
        rect: _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* ["default"].colors.black */ .Z.colors.black,
        path: _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* ["default"].colors.white */ .Z.colors.white
    } : {
        rect: _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* ["default"].colors.gray2 */ .Z.colors.gray2,
        path: _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* ["default"].colors.white */ .Z.colors.white
    };
const IconHome = (param)=>/*#__PURE__*/ {
    let { isAct =false , ...rest } = param;
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_svg_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        ...rest,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("rect", {
                x: "1.5",
                y: "1.5",
                width: "21",
                height: "21",
                rx: "5",
                fill: HOME_COLOR(isAct).rect,
                style: {
                    transition: "fill .3s"
                }
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                d: "M16.125 9.46191L11.4017 14.1852C11.2064 14.3805 10.8898 14.3805 10.6946 14.1852L7.875 11.3657",
                stroke: HOME_COLOR(isAct).path,
                strokeWidth: "2",
                strokeLinecap: "round",
                style: {
                    transition: "stroke .3s"
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconHome);


/***/ }),

/***/ 9340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5578);
/* harmony import */ var _svg_Svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4555);


const IconInfo = (param)=>/*#__PURE__*/ {
    let { ...rest } = param;
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_svg_Svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        ...rest,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("rect", {
                width: "16",
                height: "16",
                rx: "4",
                fill: "#E9E9EE"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                d: "M7.20741 14H8.79259V5.34661H7.20741V14ZM7 3.00398C7.00741 3.56175 7.45926 4.01594 8.00741 4.00797C8.54815 4.01594 9 3.56175 9 3.00398C9 2.44622 8.54815 2 8.00741 2C7.45926 2 7.00741 2.44622 7 3.00398Z",
                fill: "#C7C7D0"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconInfo);


/***/ }),

/***/ 1817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5578);
/* harmony import */ var _svg_Svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4555);


const IconMenu = (param)=>/*#__PURE__*/ {
    let { ...rest } = param;
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_svg_Svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        ...rest,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                d: "M4 7.5H20",
                stroke: "#9090A0",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                d: "M4 12H20",
                stroke: "#9090A0",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                d: "M4 16.5H20",
                stroke: "#9090A0",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconMenu);


/***/ }),

/***/ 6356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5578);
/* harmony import */ var _svg_Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4555);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2429);



const SEARCH_COLOR = (isAct)=>isAct ? {
        rect: _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* ["default"].colors.black */ .Z.colors.black,
        circle: _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* ["default"].colors.black */ .Z.colors.black
    } : {
        rect: _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* ["default"].colors.gray2 */ .Z.colors.gray2,
        circle: _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* ["default"].colors.gray2 */ .Z.colors.gray2
    };
const IconSearch = (param)=>/*#__PURE__*/ {
    let { isAct =false , ...rest } = param;
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_svg_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        ...rest,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("rect", {
                width: "2",
                height: "14.35",
                rx: "1",
                transform: "matrix(-0.707107 0.707107 0.707107 0.707107 12.75 11.3398)",
                fill: SEARCH_COLOR(isAct).rect,
                style: {
                    transition: "fill .3s"
                }
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("circle", {
                cx: "10.1622",
                cy: "10.1621",
                r: "9.35",
                transform: "rotate(-45 10.1622 10.1621)",
                fill: SEARCH_COLOR(isAct).circle,
                stroke: "white",
                strokeWidth: "1.5",
                style: {
                    transition: "fill .3s"
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IconSearch);


/***/ }),

/***/ 54:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5578);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7978);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(102);
/* harmony import */ var _icon_IconCancel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5943);
/* harmony import */ var _icon_IconChevron24pxRightLeft__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4149);





const AppBar = (param)=>{
    let { backButtonType ="chevron" , title , rightElement , onClickBackButton  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    const handleBackButton = ()=>{
        if (onClickBackButton) {
            onClickBackButton();
            return;
        }
        router.back();
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(BackButton, {
                onClick: handleBackButton,
                children: backButtonType === "chevron" ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_icon_IconChevron24pxRightLeft__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    direction: "left"
                }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_icon_IconCancel__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
            }),
            title && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(Title, {
                children: title
            }),
            rightElement && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(RightElementWrapper, {
                children: rightElement
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AppBar);
const APP_BAR_HEIGHT = "48px";
const Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("section", {
    target: "e1lb8s0i0"
})({
    position: "sticky",
    left: 0,
    top: "0",
    width: "100%",
    height: APP_BAR_HEIGHT,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: "900"
}, (param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.colors.white
    };
});
const BackButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("button", {
    target: "e1lb8s0i1"
})({
    all: "unset",
    position: "absolute",
    // NOTE: - wapper padding + design padding
    left: "calc(-20px + 8px)",
    cursor: "pointer",
    width: "3rem",
    height: "3rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const Title = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("h2", {
    target: "e1lb8s0i2"
})((param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.subTitle,
        color: theme.colors.gray6
    };
});
const RightElementWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e1lb8s0i3"
})({
    position: "absolute",
    // NOTE: - wapper padding + design padding
    right: "calc(-20px + 8px)"
});


/***/ }),

/***/ 7652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5578);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7978);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(102);
/* harmony import */ var _icon_IconHome__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5099);
/* harmony import */ var _icon_IconSearch__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6356);






const ROUTE_MATCH_ELEMENT = [
    {
        route: "/",
        matchElement: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_icon_IconHome__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            isAct: true
        }),
        nonMatchElement: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_icon_IconHome__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
    },
    {
        route: "/template",
        matchElement: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_icon_IconSearch__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            isAct: true
        }),
        nonMatchElement: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_icon_IconSearch__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
    }
];
/**
 * 
 * @example
 * 
 * ```
 * HomePage.getLayout = function getLayout(page: ReactElement) {
    return (
      <>
        {page}
        <BottomNavigation />
      </>
    );
  };
  ```
 */ const BottomNavigation = ()=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Wrapper, {
                children: ROUTE_MATCH_ELEMENT.map((param)=>/*#__PURE__*/ {
                    let { route , matchElement , nonMatchElement  } = param;
                    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Anchor, {
                        href: route,
                        children: router.asPath === route ? matchElement : nonMatchElement
                    }, route);
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(ScrollableDiv, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BottomNavigation);
const HEIGHT = "56px";
const Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("section", {
    target: "egppwp20"
})({
    width: "100%",
    height: HEIGHT,
    position: "fixed",
    bottom: 0,
    left: 0,
    display: "flex"
}, (param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.colors.white,
        borderTop: "1px solid ".concat(theme.colors.gray1)
    };
});
const Anchor = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
    target: "egppwp21"
})({
    width: "50%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const ScrollableDiv = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div", {
    target: "egppwp22"
})({
    height: HEIGHT,
    appearance: "none"
});


/***/ }),

/***/ 8720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5578);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(102);
/* harmony import */ var _icon_IconAlarm__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4677);
/* harmony import */ var _icon_IconMenu__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1817);





const DefaultAppBar = ()=>{
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(Wrapper, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(ButtonWrapper, {
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(StyledLink, {
                    href: "/notice",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_icon_IconAlarm__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(Button, {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_icon_IconMenu__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DefaultAppBar);
const Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("section", {
    target: "ej887y50"
})({
    position: "sticky",
    top: "0",
    left: "0",
    width: "100%",
    height: "48px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center"
}, (param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.colors.gray1
    };
});
const ButtonWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "ej887y51"
})({
    position: "absolute",
    top: "0",
    right: "-12px",
    height: "100%",
    display: "flex"
});
const Button = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("button", {
    target: "ej887y52"
})({
    all: "unset",
    cursor: "pointer",
    width: "48px",
    height: "48px",
    textAlign: "center"
});
const StyledLink = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
    target: "ej887y53"
})({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "48px",
    height: "48px"
});


/***/ }),

/***/ 8337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5578);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(102);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6618);
/* harmony import */ var _PortalWrapper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3076);
/* harmony import */ var _StyledMotionScrim__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5711);
/* harmony import */ var _constants_motions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9370);
/* harmony import */ var _hooks_scroll_usePreventScroll__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9168);







const BottomSheet = (param)=>{
    let { setToClose , children , isShowing  } = param;
    (0,_hooks_scroll_usePreventScroll__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(isShowing);
    const onClickScrim = (e)=>{
        if (e.target !== e.currentTarget) return;
        setToClose();
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_PortalWrapper__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        isShowing: isShowing,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_StyledMotionScrim__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            onClick: onClickScrim,
            variants: _constants_motions__WEBPACK_IMPORTED_MODULE_3__/* .defaultFadeInVariants */ .JD,
            initial: "initial",
            animate: "animate",
            exit: "exit",
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(StyledMotionContent, {
                variants: bottomSheetVariants,
                children: children
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (BottomSheet);
const StyledMotionContent = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(framer_motion__WEBPACK_IMPORTED_MODULE_6__.m.div, {
    target: "e97q67s0"
})("position:absolute;top:100%;width:100%;min-height:420px;max-height:95%;padding-top:16px;padding-left:20px;padding-right:20px;background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, ";border-radius:20px 20px 0 0;overflow:hidden;z-index:1000;");
const bottomSheetVariants = {
    initial: {
        y: 0,
        transition: {
            duration: 0.3,
            ease: _constants_motions__WEBPACK_IMPORTED_MODULE_3__/* .defaultEasing */ .gc
        },
        willChange: "transform"
    },
    animate: {
        y: "-100%",
        transition: {
            duration: 0.3,
            ease: _constants_motions__WEBPACK_IMPORTED_MODULE_3__/* .defaultEasing */ .gc
        },
        willChange: "transform"
    },
    exit: {
        y: 0,
        transition: {
            duration: 0.3,
            ease: _constants_motions__WEBPACK_IMPORTED_MODULE_3__/* .defaultEasing */ .gc
        },
        willChange: "transform"
    }
};


/***/ }),

/***/ 3076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5578);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4654);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4207);



const PortalWrapper = (param)=>{
    let { children , isShowing  } = param;
    const container =  true && document.body;
    return container ? /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_0__.createPortal)(/*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .AnimatePresence */ .M, {
        mode: "wait",
        children: isShowing && children
    }), container) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (PortalWrapper);


/***/ }),

/***/ 5711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(102);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6618);


const StyledMotionScrim = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(framer_motion__WEBPACK_IMPORTED_MODULE_1__.m.div, {
    target: "e1apb9yq0"
})("position:fixed;top:0;left:0;z-index:900;width:100vw;height:100%;background-color:rgba(0,0,0,0.3);overflow:hidden;");
/* harmony default export */ __webpack_exports__["Z"] = (StyledMotionScrim);


/***/ }),

/***/ 6580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5578);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9953);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(102);
/* harmony import */ var _chip_Chip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5110);




const CategorySection = (param)=>{
    let { defaultColor  } = param;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(Wrapper, {
        children: CATEGORY_DUMMY.map((name)=>/*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_chip_Chip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                label: name,
                color: defaultColor
            }, name))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CategorySection);
const CATEGORY_DUMMY = [
    "물놀이",
    "디프만",
    "호캉스",
    "일상",
    "운동",
    "유럽여행"
];
const Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e1g8y4i00"
})("display:flex;column-gap:4px;overflow-x:auto;white-space:nowrap;");


/***/ }),

/***/ 4555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5578);

const Svg = (param)=>{
    let { size , width , height , color , isUsingFill =false , children , viewBox ="0 0 24 24" , ...rest } = param;
    var ref, ref1;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: (ref = width !== null && width !== void 0 ? width : size) !== null && ref !== void 0 ? ref : 24,
        height: (ref1 = height !== null && height !== void 0 ? height : size) !== null && ref1 !== void 0 ? ref1 : 24,
        fill: isUsingFill ? color !== null && color !== void 0 ? color : "currentColor" : "none",
        viewBox: viewBox,
        ...rest,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Svg);


/***/ }),

/***/ 9370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JD": function() { return /* binding */ defaultFadeInVariants; },
/* harmony export */   "_5": function() { return /* binding */ defaultFadeInUpVariants; },
/* harmony export */   "gc": function() { return /* binding */ defaultEasing; },
/* harmony export */   "rv": function() { return /* binding */ staggerOne; }
/* harmony export */ });
/* unused harmony export staggerHalf */
const defaultEasing = [
    0.6,
    -0.05,
    0.01,
    0.99
];
const staggerOne = {
    animate: {
        transition: {
            staggerChildren: 0.1
        }
    }
};
const staggerHalf = {
    animate: {
        transition: {
            staggerChildren: 0.05
        }
    }
};
const defaultFadeInVariants = {
    initial: {
        opacity: 0,
        transition: {
            duration: 0.3,
            ease: defaultEasing
        },
        willChange: "opacity"
    },
    animate: {
        opacity: 1,
        transition: {
            duration: 0.3,
            ease: defaultEasing
        },
        willChange: "opacity"
    },
    exit: {
        opacity: 0,
        transition: {
            duration: 0.3,
            ease: defaultEasing
        },
        willChange: "opacity"
    }
};
const defaultFadeInUpVariants = {
    initial: {
        opacity: 0,
        y: 30,
        transition: {
            duration: 0.3,
            ease: defaultEasing
        },
        willChange: "opacity, transform"
    },
    animate: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.3,
            ease: defaultEasing
        },
        willChange: "opacity, transform"
    },
    exit: {
        opacity: 0,
        y: 30,
        transition: {
            duration: 0.3,
            ease: defaultEasing
        },
        willChange: "opacity, transform"
    }
};


/***/ }),

/***/ 9958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ mockCheckboxGroupOptions; },
/* harmony export */   "Q": function() { return /* binding */ mockCheckboxGroupTitle; }
/* harmony export */ });
const mockCheckboxGroupTitle = "디프만 UT 준비물";
const mockCheckboxGroupOptions = [
    {
        name: "구민규",
        id: "1"
    },
    {
        name: "김민걸",
        id: "2"
    },
    {
        name: "명수찬",
        id: "3"
    },
    {
        name: "박한솔",
        id: "4"
    },
    {
        name: "오혜성",
        id: "5"
    },
    {
        name: "윤가빈",
        id: "6"
    },
    {
        name: "이영희",
        id: "7"
    },
    {
        name: "이은지",
        id: "8"
    },
    {
        name: "이종원",
        id: "9"
    },
    {
        name: "조성민",
        id: "10"
    }
];



/***/ }),

/***/ 9168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePreventScroll; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9953);

/**
 * `condition`에 따라 body의 스크롤을 막습니다
 *
 * @param condition
 * 스크롤을 방지할 상태 입니다
 *
 */ function usePreventScroll() {
    let condition = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (typeof document === "undefined") return;
        if (condition) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "unset";
        return ()=>{
            document.body.style.overflow = "unset";
        };
    }, [
        condition
    ]);
}


/***/ }),

/***/ 403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-5128de1cdb/0/cache/@emotion-react-npm-11.10.0-06b9abb1e2-6d692e43ff.zip/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5578);
// EXTERNAL MODULE: ./.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(9953);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-styled-virtual-2aaf7f2de3/0/cache/@emotion-styled-npm-11.10.0-ee745c48ee-f2a3e9798f.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(102);
// EXTERNAL MODULE: ./src/components/navigation/BottomNavigation.tsx
var BottomNavigation = __webpack_require__(7652);
// EXTERNAL MODULE: ./src/components/navigation/DefaultAppBar.tsx
var DefaultAppBar = __webpack_require__(8720);
// EXTERNAL MODULE: ./src/components/route-search/CategorySection.tsx
var CategorySection = __webpack_require__(6580);
// EXTERNAL MODULE: ./src/components/button/ContainedButton.tsx
var ContainedButton = __webpack_require__(7566);
// EXTERNAL MODULE: ./src/components/icon/IconChevron24pxRightLeft.tsx
var IconChevron24pxRightLeft = __webpack_require__(4149);
;// CONCATENATED MODULE: ./src/components/route-search/ListRequestSection.tsx





const ListRequestSection = ()=>{
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MainTitle, {
                children: "찾으시는 리스트가 없나요?"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubTitle, {
                children: "필요한 상황의 리스트를 말씀해 주세요."
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledButton, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Emoji, {
                                role: "img",
                                "aria-label": "writing hand",
                                children: "✍"
                            }),
                            "리스트 요청하기"
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconChevron24pxRightLeft/* default */.Z, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var route_search_ListRequestSection = (ListRequestSection);
const MainTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "esrudnq0"
})((param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.title2,
        color: theme.colors.black
    };
}, ";margin-bottom:4px;");
const SubTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "esrudnq1"
})((param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.body1,
        color: theme.colors.gray4
    };
}, ";margin-bottom:16px;");
const StyledButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(ContainedButton/* default */.Z, {
    target: "esrudnq2"
})("// TODO:클릭 시 디자인 적용\n  ", (param)=>{
    let { theme  } = param;
    return {
        color: theme.colors.black,
        backgroundColor: theme.colors.white
    };
}, "  display:flex;align-items:center;justify-content:space-between;width:100%;padding:20px;");
const Emoji = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "esrudnq3"
})("margin-right:8px;");

// EXTERNAL MODULE: ./src/components/checkbox/Checkbox.tsx
var Checkbox = __webpack_require__(2986);
// EXTERNAL MODULE: ./src/components/checkbox/CheckboxWithText.tsx
var CheckboxWithText = __webpack_require__(4);
;// CONCATENATED MODULE: ./src/components/checkbox/CheckboxGroup.tsx





const CheckboxGroup = (param)=>{
    let { title , options  } = param;
    const [checkStatus, setCheckStatus] = (0,react.useState)(new Array(options.length).fill(false));
    const toggleSingleCheckbox = (clikedIdx)=>{
        setCheckStatus((prev)=>prev.map((item, i)=>i === clikedIdx ? !item : item));
    };
    const toggleCheckAllBtn = (e)=>{
        setCheckStatus((prev)=>[
                ...prev.fill(e.target.checked)
            ]);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHeader, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, {
                        textLabel: "전체 선택",
                        onToggle: toggleCheckAllBtn,
                        checked: checkStatus.every((item)=>!!item),
                        testId: "check-all-btn"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Counter, {
                children: [
                    "".concat(checkStatus.filter((item)=>item === true).length, "/").concat(options.length),
                    "개"
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckboxList, {
                children: options.map((param, idx)=>/*#__PURE__*/ {
                    let { name , id  } = param;
                    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckboxWithText/* default */.Z, {
                        checked: checkStatus[idx],
                        onToggle: ()=>{
                            toggleSingleCheckbox(idx);
                        },
                        testId: "single-check-btn",
                        children: name
                    }, id);
                })
            })
        ]
    });
};
/* harmony default export */ var checkbox_CheckboxGroup = (CheckboxGroup);
const StyledHeader = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("header", {
    target: "e5ktyta0"
})("display:flex;align-items:center;justify-content:space-between;");
const Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e5ktyta1"
})((param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.title2
    };
}, "  color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";");
const Counter = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e5ktyta2"
})("display:block;", (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.caption2
    };
}, ";color:#7a7a7a;");
const CheckboxList = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e5ktyta3"
})("margin-block:16px;height:216px;overflow:auto;& > div{margin-top:4px;}& > div:first-child{margin-top:0;}");

;// CONCATENATED MODULE: ./src/components/route-search/SearchCard.tsx




const SearchCard = (param)=>{
    let { title , options , onSubmit  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(checkbox_CheckboxGroup, {
                title: title,
                options: options
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContainedButton/* default */.Z, {
                onClick: onSubmit,
                children: "내 리스트에 추가하기"
            })
        ]
    });
};
/* harmony default export */ var route_search_SearchCard = (SearchCard);
const Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1wcppr80"
})("border-radius:16px;background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, ";padding:20px 20px 16px 20px;");

// EXTERNAL MODULE: ./src/components/button/LabelButton.tsx
var LabelButton = __webpack_require__(1919);
// EXTERNAL MODULE: ./src/components/icon/IconAdd.tsx
var IconAdd = __webpack_require__(2976);
// EXTERNAL MODULE: ./src/components/navigation/AppBar.tsx
var AppBar = __webpack_require__(54);
// EXTERNAL MODULE: ./src/components/portal/BottomSheet.tsx
var BottomSheet = __webpack_require__(8337);
;// CONCATENATED MODULE: ./src/components/route-search/TemplateAppendBottomSheet.tsx







const TemplateAppendBottomSheet = (param)=>{
    let { isShowing , setToClose  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BottomSheet["default"], {
        isShowing: isShowing,
        setToClose: setToClose,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppBar/* default */.Z, {
                backButtonType: "cancel",
                title: "추가하기",
                rightElement: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LabelButton/* default */.Z, {
                    size: "large",
                    children: "완료"
                }),
                onClickBackButton: setToClose
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                style: {
                    marginTop: 8
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CategorySection/* default */.Z, {
                    defaultColor: "gray"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(List, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItem, {
                        children: "기존 리스트 1"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItem, {
                        children: "기존 리스트 2"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ListItem, {
                        newItem: true,
                        selected: true,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconAdd/* default */.Z, {}),
                            "디프만 UT 준비물로 리스트 추가"
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var route_search_TemplateAppendBottomSheet = (TemplateAppendBottomSheet);
const List = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("ul", {
    target: "e6p6awm0"
})("list-style:none;margin-top:24px;");
const ListItem = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("li", {
    target: "e6p6awm1"
})({
    display: "flex",
    width: "calc(100% + 20px * 2)",
    alignItems: "center",
    height: 48,
    marginLeft: -20,
    paddingLeft: 20
}, (param)=>{
    let { theme  } = param;
    return {
        borderBottom: "1px solid ".concat(theme.colors.gray1),
        color: "".concat(theme.colors.gray6)
    };
}, (props)=>props.newItem && {
        color: props.theme.colors.gray3,
        borderBottom: "none"
    }, (props)=>props.selected && {
        backgroundColor: props.theme.colors.gray1,
        boxShadow: "0px 4px 4px 0px #00000040"
    });

// EXTERNAL MODULE: ./src/fixtures/checkboxGroup.mock.ts
var checkboxGroup_mock = __webpack_require__(9958);
;// CONCATENATED MODULE: ./src/pages/template/index.page.tsx










const Template = ()=>{
    const [isBottomSheetOpen, setIsBottomSheetOpen] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_page_Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_page_Title, {
                children: [
                    "상황에 맞는",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                    "소지품을 추천해 드릴게요"
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CategorySection/* default */.Z, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardsWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_search_SearchCard, {
                    title: checkboxGroup_mock/* mockCheckboxGroupTitle */.Q,
                    options: checkboxGroup_mock/* mockCheckboxGroupOptions */.E,
                    onSubmit: ()=>{
                        setIsBottomSheetOpen(true);
                    }
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_search_ListRequestSection, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(route_search_TemplateAppendBottomSheet, {
                isShowing: isBottomSheetOpen,
                setToClose: ()=>{
                    setIsBottomSheetOpen(false);
                }
            })
        ]
    });
};
Template.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultAppBar/* default */.Z, {}),
            page,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BottomNavigation/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var index_page = (Template);
const index_page_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1yimkdl0"
})("padding-top:8px;padding-bottom:41.5px;");
const index_page_Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e1yimkdl1"
})((param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.title2
    };
}, ";margin-bottom:24px;");
const CardsWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1yimkdl2"
})("display:flex;flex-direction:column;row-gap:16px;margin:16px 0 24px 0;");


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [618,862,774,888,179], function() { return __webpack_exec__(5953); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);